import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios/axiosInstance';

export const fetchAllNoticesByAdmin = createAsyncThunk(
  'notice/fetchAllNoticesByAdmin',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('/admin/notices', { params });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to fetch notices' }
      );
    }
  }
);
